import axios from '@/axiosInterceptor';
// const state = () => ({})

// getters
// const getters = {}

// actions
const actions = {
  async createDomain(_, { value, companyId }) {
    let body = {
      company_domain: {
        value: value,
        company_id: companyId,
      },
    };
    try {
      let res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/company_domains`,
        body
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
  async updateDomain(_, { id, value }) {
    let body = {
      company_domain: {
        value: value,
      },
    };
    try {
      let res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/company_domains/${id}`,
        body
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
  async deleteDomain(_, id) {
    try {
      let res = await axios.delete(
        `${process.env.API_MONITOR}/api/v1/company_domains/${id}`
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
};

function handleAxiosError(e) {
  const status = e.response?.status;
  if (
    axios.isAxiosError(e) &&
    status &&
    [401, 403, 404, 422].includes(status)
  ) {
    return e.response;
  } else {
    throw e;
  }
}

// const mutations = {}

export default {
  namespaced: true,
  // state,
  // getters,
  actions,
  // mutations,
};
